import React from 'react';
import FadeIn from './FadeIn';

export default function Curriculum() {
  const days = [
    { day: 1, title: "The Bravery Check", desc: "How to look at your bank account without panic, and find your exact starting line." },
    { day: 2, title: "Stop the Bleed", desc: "Identifying and pausing the hidden auto-drafts that cause surprise overdrafts." },
    { day: 3, title: "The Priority Matrix", desc: "Exactly which bills to pay first when you don't have enough for everything." },
    { day: 4, title: "Paycheck Mapping", desc: "Assigning every upcoming dollar a job before it even hits your account." },
    { day: 5, title: "Building the Buffer", desc: "How to create a tiny, safe cushion to protect against the next small emergency." },
    { day: 6, title: "The 15-Minute Ritual", desc: "The simple weekly routine to maintain total control and visibility." },
    { day: 7, title: "Calm Confidence", desc: "Reviewing your new system and stepping into your next payday with peace of mind." }
  ];

  return (
    <section className="py-16 bg-blue-900 text-white px-4 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <FadeIn>
          <h2 className="text-3xl font-bold mb-10 text-center">Your 7-Day Path to Control</h2>
          <div className="space-y-4">
            {days.map((item) => (
              <div key={item.day} className="flex gap-4 p-4 rounded-lg bg-blue-800/50 border border-blue-700/50">
                <div className="flex-shrink-0 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center font-bold">
                  D{item.day}
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">{item.title}</h3>
                  <p className="text-blue-200 text-sm leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
}